import { serverError } from "../Csi/csi.types";

export class Loader {
    public static loadUrl(customEnvVariables: any): string{
        // creo la URL di lancio
        let url: string = window.location.origin;

        if (customEnvVariables.BUILD_MODE === 'development') {
            url = url+"?game="+customEnvVariables.GAME;
            url = url+"&debug="+(customEnvVariables.DEBUG ?? "false");
            url = url+"&gsp="+customEnvVariables.GSP;
            url = url+"&gsh="+customEnvVariables.GSH;
            url = url+"&mode="+(customEnvVariables.MODE ?? "free");
            url = url+"&network="+(customEnvVariables.NETWORK ?? "base");
            url = url+"&operator="+(customEnvVariables.OPERATOR ?? "");
            url = url+"&session="+(customEnvVariables.SESSION ?? "");
            url = url+"&jurisdiction="+(customEnvVariables.JURISDICTION ?? "");
            url = url+"&language="+(customEnvVariables.LANGUAGE ?? "");
            url = url+"&currency="+(customEnvVariables.CURRENCY ?? "");
            url = url+"&env="+(customEnvVariables.ENV ?? "");
            url = url+"&geapi="+(customEnvVariables.GEAPI ?? "1.07");
            url = url+"&gsapi="+(customEnvVariables.GSAPI ?? "1.07");
            url = url+"&gcapi="+(customEnvVariables.GCAPI ?? "1.07");
            url = url+"&gsver="+(customEnvVariables.GSVER ?? "1.07");
    
            console.log("Url di lancio (DEVELOP)", url)
        }
        else{
            const url = window.location.href;
            console.log("Url di lancio (PROD)", url);
            return url;
        }
        return url;
    }

    public static loadParamsAndSettings(url: any, cache: any): any{
        const searchParams = new URL(url).searchParams;
        const config = {
            params: {
                debug: searchParams.get('debug') ?? "false",
                network : searchParams.get('network'),
                gsp: searchParams.get('gsp') ?? window.location.protocol,
                gsh: searchParams.get('gsh'),
                game: searchParams.get('game'),
                session: searchParams.get('session'),
                jurisdiction: searchParams.get('jurisdiction'),
                info: cache.json.get('info'),
                gameData: cache.json.get('data'),
                serverAPI: searchParams.get('gsapi') ?? searchParams.get('gsver') ?? "1.07",
                serverVersion: searchParams.get('gsver') ?? "1.07",
                engineApi: searchParams.get('geapi'),
                serverHost: searchParams.get('gsh'), 
                mode: searchParams.get('mode') ?? 'free',
                language: searchParams.get('language') ?? 'en_EN',
                currency: searchParams.get('currency') ?? 'EUR',
                operator: searchParams.get('operator'),
                env: searchParams.get('env'),

            },
            gameSettings: {
                mode: searchParams.get('mode') ?? 'free',
                language: searchParams.get('language') ?? 'en',
                currency: searchParams.get('currency') ?? 'EUR',
                operator: searchParams.get('operator'),
                env: searchParams.get('env'),
            }
        };
        return config
    }
}